export default __webpack_public_path__ + "1c34c4da1f3508412715a15b86249277.png";